"use client";

import Link from "next/link";

import clsx from "clsx";

import Brands from "shared-lib/Brands";
import { ClickServer } from "shared-lib/clickserver";
import * as gtag from "shared-lib/gtag";
import { getShortHeadline } from "shared-lib/helpers/articleFunctions";
import { brand } from "shared-lib/helpers/envFunctions";
import {
  TRACKING_EVENTS,
  logStatsig,
  TRACKING_CATEGORIES,
} from "shared-lib/helpers/statsigFunctions";

import ArticleImage from "@/components/article/ArticleImage";

const themeClasses = {
  textClass: "",
  bgClass: "",
};
switch (brand.id) {
  case Brands.commandcooking:
    themeClasses.textClass = "text-black";
    themeClasses.bgClass = "bg-opacity-20 bg-theme-primary";
    break;
  case Brands.cookingprofessionally:
    themeClasses.textClass = "text-theme-primary";
    themeClasses.bgClass = "bg-opacity-20 bg-theme-secondary";
    break;
  case Brands.easiereats:
    themeClasses.textClass = "text-white";
    themeClasses.bgClass = "bg-theme-primary";
    break;
  case Brands.heartlandcooking:
    themeClasses.textClass = "text-theme-secondary";
    themeClasses.bgClass = "bg-theme-primary";
    break;
  case Brands.lazycooking:
    themeClasses.textClass = "text-black";
    themeClasses.bgClass = "bg-opacity-20 bg-theme-secondary";
    break;
  case Brands.mamascooking:
    themeClasses.textClass = "text-black";
    themeClasses.bgClass = "bg-theme-secondary";
    break;
  case Brands.recipereader:
    themeClasses.textClass = "text-black";
    themeClasses.bgClass = "bg-opacity-20 bg-theme-secondary";
    break;
  case Brands.recipesaver:
    themeClasses.textClass = "text-black";
    themeClasses.bgClass = "bg-opacity-20 bg-theme-secondary";
    break;
  case Brands.recipesdirect:
    // Tommy made this one since we are getting rid of RecipesDirect
    //  and didn't have a design for it
    themeClasses.textClass = "text-black";
    themeClasses.bgClass = "bg-opacity-20 bg-theme-secondary";
    break;
}

export default function ArticleTile({
  className = "",
  article,
  index = 0,
  exploreMore = false,
  priority = false,
  onClick = () => {
    return;
  },
}: {
  className?: string;
  article: Article;
  index: number;
  exploreMore?: boolean;
  priority?: boolean;
  onClick?: () => void;
}) {
  return (
    <Link
      onClick={() => {
        onClick();

        if (exploreMore) {
          gtag.event({
            action: TRACKING_EVENTS.explore_more_tile_click,
            category: TRACKING_CATEGORIES.navigation,
            label: index.toString(),
          });
          logStatsig(TRACKING_EVENTS.explore_more_tile_click, {
            index: index.toString(),
            tile_type: "article",
          });
          ClickServer.track(TRACKING_EVENTS.explore_more_tile_click, {
            index: index.toString(),
            tile_type: "article",
          });
        } else {
          gtag.event({
            action: TRACKING_EVENTS.article_tile_click,
            category: TRACKING_CATEGORIES.navigation,
            label: index.toString(),
          });
          logStatsig(TRACKING_EVENTS.article_tile_click, {
            index: index.toString(),
          });
          ClickServer.track(TRACKING_EVENTS.article_tile_click, {
            index: index.toString(),
          });
        }
      }}
      href={`/article/${article.slug}`}
      className={clsx(
        className,
        "group flex flex-col px-0 no-underline h-64 md:h-48",
        "rounded-md",
      )}
    >
      <div className="w-full overflow-hidden md:h-48">
        <ArticleImage
          className="mx-auto rounded-t-md"
          noRounding={true}
          article={article}
          size="small"
          priority={priority}
        />
      </div>

      <div
        className={clsx(
          "flex-grow content-center",
          "rounded-b-md px-2 pb-0",
          themeClasses.bgClass,
        )}
      >
        <div
          className={clsx(
            "mt-2 px-2 text-xs uppercase tracking-widest",
            themeClasses.textClass,
          )}
        >
          {article.categories?.items.map((x) => x.name).join(", ")}
        </div>

        <div
          className={clsx(
            "w-full px-2 text-lg leading-8 md:truncate",
            themeClasses.textClass,
          )}
        >
          <span>{getShortHeadline(article)}</span>
        </div>
      </div>
    </Link>
  );
}
